export default "__VITE_ASSET__7aYqIvKN__"